module.exports = __webpack_public_path__ + "img/phase2-2014-04.e07e4646.jpg";